import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import './LastThreeMonths.css';

// Register required components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const LastThreeMonths = () => {
  const [isEnabled, setIsEnabled] = useState(true);

  const handleToggle = () => {
    setIsEnabled((prev) => !prev);
  };

  const data = {
    labels: ['Dec', 'Jan', 'Feb'],
    datasets: [
      {
        label: 'Expenses',
        data: [196, 230, 160],
        backgroundColor: '#6a5acd',
        borderRadius: 4,
        barThickness: 50,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `$${context.raw}`,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: '#666',
          font: {
            size: 14,
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 115,
          color: '#666',
          font: {
            size: 12,
          },
        },
        grid: {
          drawBorder: false,
          color: '#E0E0E0',
        },
      },
    },
    plugins: {
      datalabels: {
        display: true,
        color: '#ffffff',
        align: 'end',
        anchor: 'end',
        formatter: (value) => `$${value}`,
      },
    },
  };

  return (
    <div className="card-content">
      <Bar data={data} options={options} />
    </div>
  );
};

export default LastThreeMonths;
